export class LoginRequestModel {
    constructor(userName, password, returnUrl) {
        this.userName = "";
        this.password = "";
        this.returnUrl = "";
        this.userName = userName;
        this.password = password;
        this.returnUrl = returnUrl;
    }
}
